import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';

import React, { useEffect, useMemo, useRef, useState } from 'react';
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import { Trans, useTranslation } from 'react-i18next';
import { Dialog } from 'primereact/dialog';
import { Checkbox } from 'primereact/checkbox';

import AuthenticationService from '../service/AuthenticationService';
import EventBus from "../common/EventBus";
import CompanyService from '../service/CompanyService';
//import { useHistory } from 'react-router-dom';
import { useNavigate, useParams } from 'react-router-dom';
import utils from '../constants/utils';
import AccountService from '../service/AccountService';
import AuthService from '../security/AuthService';
import PasswordChecklist from "react-password-checklist"
import Constants from '../constants/Constants';
import { Toast } from 'primereact/toast';
import { ContractDetail } from '../pages/contracts/ContractDetail';

const CustomRegister = (props) => {

    const navigate = useNavigate();
    const { t } = useTranslation();
    const toast = useRef(null);

    const [displayLoadingDialog, setDisplayLoadingDialog] = useState(false);

    const [companies, setCompanies] = useState([]);
    const [watilistemail, setWatilistemail] = useState();
    const [userSelected, setUserSelected] = useState(false);

    const [verificationUser, setVerificationUser] = useState();
    const [contact, setContact] = useState("");
    const [newID, setNewID] = useState(-1);

    const [displayKVKK, setDisplayKVKK ] = useState(false);
    

    let { usermail, verificationToken, action } = useParams();
    console.log("CustomRegister usermail: ", usermail, " verificationToken: ", verificationToken);

    console.log("CustomRegister props: ", props);


    const [checkApprove, setCheckApprove] = useState(false);
    const [checkCommercialMail, setCheckCommercialMail] = useState(false);




    const showLoading = () => {
        setDisplayLoadingDialog(true);
    }
    const hideLoading = () => {
        setDisplayLoadingDialog(false);
    }



    console.log("CustomVerification useEffect usermail: ", verificationUser, action);
    useEffect(() => {
        if (action === 'verification') {
            console.log("CustomVerification useEffect usermail: ", usermail, " verificationToken: ", verificationToken, " action:", action);
            verifyUser();

        }
        if (action === 'reference') {
            console.log("CustomVerification useEffect usermail: ", usermail, " verificationToken: ", verificationToken, " action:", action);
            verifyUser();

        }
        if (action === 'update') {
            console.log("CustomVerification useEffect usermail: ", usermail, " verificationToken: ", verificationToken, " action:", action);
            // verifyUser();

        }
    }, []);



    const verifyUser = () => {

        console.log("CustomVerification usermail: ", usermail, " verificationToken: ", verificationToken, " action:", action);
        showLoading();
        AccountService.inquiereUserVerification(usermail, verificationToken).then(
            (response) => {
                console.log("inquiereUserVerification", response.data.data.dataList)
                if (response?.data?.data?.dataList?.length > 0) {
                    // setVerification(response?.data?.data?.dataList[0]);
                    loadVerificationData(response?.data?.data?.dataList[0]);
                } else {
                    toast.current.show({ severity: 'error', summary: t("global_error"), detail: t("verification_error_descr2"), life: 5000 });
                }
                hideLoading();

            },
            (error) => {
                hideLoading();
                console.log("errror", error);
                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {
                    console.log("do loggout");
                    navigate('/')
                } else {
                    toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );


    }
    const loadVerificationData = (param) => {
        setVerificationUser(param);

        if (param.userType === 'company') {
            loadData();
        }

        props.setUserType(param.userType);
        props.setFirstName(param.firstName);
        props.setLastName(param.lastName);
        props.setEmail(param.email);

    }

    const checkContact = () => {
        let _contacts = props.contacts;

        let _newId = newID - 1;
        setNewID(_newId);

        if (!_contacts?.length > 0) {

            _contacts = [];
        }


        let _id = parseInt(_newId);

        console.log("addContactSite _id", _id, props.contacts, _newId);

        let _val = contact;
        if (!(_val.startsWith("http://") || _val.startsWith("https://"))) {
            _val = "https://" + _val;
        }

        let _contact = { id: '' + _id, val: _val, key: "contacts" };
        return _contact;
    }

    const addContactSite = (param) => {

        if (contact?.length === 0) return;

        let _contact = checkContact();


        props.setContacts([...props.contacts, _contact]);
        setContact("");

    }
    const removeContactSite = (param) => {
        console.log("removeContactSite", param);
        props.setContacts(
            props.contacts.filter(a => a.id !== param.id)
        );
    }
    const updateContact = (param) => {


    }
    const renderContacts = () => {


        return (
            <div className="grid p-2 w-12">
                {
                    props.contacts?.map((param, index) => {

                        return (
                            <div key={index} className="col-12 md:col-12">
                                <div className='flex justify-content-between w-12'>

                                    <Button icon="fas fa-minus" className="p-button-rounded p-button-header mr-2 mb-2"
                                        onClick={(e) => { removeContactSite(param); }}
                                    />

                                    <InputText value={param.val} onChange={(e) => updateContact(e.target.value)} disabled
                                        className="inputtext_raunded p-inputtext w-12" type="text" placeholder={t('global_text_profile_contact')}></InputText>

                                </div>

                            </div>
                        )
                    })
                }
                {props.contacts?.length < 5 &&
                    <div className="col-12 md:col-12">
                        <div className='flex justify-content-between w-12'>
                            <Button icon="pi pi-plus" className="p-button-rounded p-button-header mr-2 mb-2"
                                onClick={(e) => { addContactSite(e.target.value); }}
                            />

                            <InputText value={contact} onChange={(e) => setContact(e.target.value)}
                                className="inputtext_raunded p-inputtext w-12" type="text" placeholder={t('global_text_profile_contact')}></InputText>
                        </div>
                    </div>
                }
            </div>
        )



    }

    const passwordInfo = () => {
        console.log("passwordInfo", verificationUser);

        if (verificationUser) {
            return (

                <div className="col-12 md:col-12 flex justify-content-center w-full" >
                    <div className="register-content  w-12   p-3">
                        <div className="col-12 md:col-12" style={{
                            wordWrap: 'break-word',
                            paddingBottom: 5,
                        }}>
                            {t('verification_descr1')}
                        </div>
                        <div className="col-12 md:col-12">
                            <div className="grid formgrid">
                                <div className="col-12 md:col-12  p-3">
                                    <InputText id="userName" value={props.userName} onChange={(e) => props.setUserName(e.target.value)} autoComplete="off"
                                        className="inputtext_raunded p-inputtext " type="text" placeholder={t('global_text_user_name')}></InputText>
                                </div>
                                <div className="col-12 md:col-12  p-3">
                                    <InputText type="password" placeholder={t("global_text_password")}
                                        onChange={(e) => props.setPassword(e.target.value)}
                                        value={props.password}
                                        required
                                        className="inputtext_raunded p-inputtext "
                                    />

                                </div>
                                <div className="col-12 md:col-12  p-3">
                                    <InputText type="password" placeholder={t("global_text_confirmpassword")}
                                        onChange={(e) => props.setPasswordConfirm(e.target.value)}
                                        value={props.passwordConfirm}
                                        required
                                        className="inputtext_raunded p-inputtext "
                                    />
                                </div>
                                <div className="col-12 md:col-12  p-3">
                                    <PasswordChecklist
                                        rules={["minLength", "specialChar", "number", "capital", "match"]}
                                        minLength={5}
                                        value={props.password}
                                        valueAgain={props.passwordConfirm}
                                        onChange={(isValid) => { }}
                                        messages={{
                                            minLength: t('validation_password_minlength'),
                                            specialChar: t('validation_password_specialchar'),
                                            number: t('validation_password_number'),
                                            capital: t('validation_password_capital'),
                                            match: t('validation_password_match')
                                        }}
                                    />
                                </div>
                                {action === 'reference' &&
                                    <div className="col-12 md:col-12  p-3">
                                        <div className="field-checkbox">
                                            <Checkbox inputId="approvelast" checked={checkApprove} onChange={e => setCheckApprove(e.checked)} />

                                            <a onClick={() => setDisplayKVKK(true)} style={{ paddingLeft: '2px', paddingRight: '2px' ,cursor: 'pointer'}} >{t('global_text_approvekvkk')}</a>
                                            {t('global_text_approvelast')}

                                        </div>
                                        <div className="field-commercialmail mt-2">
                                            <Checkbox inputId="binary" checked={checkCommercialMail} onChange={e => setCheckCommercialMail(e.checked)} />

                                            {t('global_text_commercialmail')}

                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>

            )
        } else if ((action === 'verification' || action === 'reference') && !displayLoadingDialog && !userSelected) {
            return (
                <div className="col-12 md:col-12 flex justify-content-center w-full" >
                    <div className="register-content  w-12   p-3">
                        <div className="col-12 md:col-12" style={{
                            wordWrap: 'break-word',
                            paddingBottom: 5,
                        }}>
                            {t('verification_error_descr2')}
                        </div>
                    </div>
                </div>

            )
        }
    }




    const loadData = () => {
        console.log("props.companyTypes", props.companyTypes, props.companyTypes?.length)
        if (props.companyTypes?.length === 0) {
            showLoading();
            CompanyService.inquiereCompanyTypes().then(
                (response) => {
                    console.log("inquiereCompanyTypes", response.data.data.dataList)
                    if (response.data.data.dataList.length > 0) {
                        let _companyTypes = response.data.data.dataList;
                        props.setCompanyTypes(_companyTypes);
                    }
                    hideLoading();
                },
                (error) => {
                    hideLoading();
                    console.log("errror", error);
                    const _content =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();

                    console.log(_content);

                    if (error?.response?.status === 403 || error?.Error?.includes("403")) {
                        console.log("do loggout");
                        navigate('/')
                    } else {
                        toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                    }
                }
            );

        }
    }
    const onSelectedCompanyType = (param) => {
        console.log("onSelectedCompanyType", param)
        props.setSelectedCompanyType(param);
        props.setCompanyType(param.id);

    }


    const onSelectUserType = (param) => {
        if (verificationUser) {
            toast.current.show({ severity: 'error', summary: t("global_error"), detail: t("register_no_change_user_type"), life: 5000 });
        } else {

            if ((action === 'verification' || action === 'reference') && !userSelected) {
                setUserSelected(true);
                // props.clear();
            }
            if (param === 'artlover' && (!usermail || !verificationToken)) {
                //   toast.current.show({ severity: 'error', summary: t("global_error"), detail: t("register_no_verificationToken"), life: 5000 });
                //props.setUserType(null);
                props.setUserType(param);

            } else {
                if (param === 'artlover') {
                    props.setEmail(usermail);
                } else {

                }

                props.setUserType(param);
                console.log("test palette", param)
                if (param === 'company') {
                    loadData();
                }
            }
        }
    }


    const checkButtonStatus = () => {

        console.log("checkButtonStatus", props.userType, props.firstName, props.lastName, props.email, checkApprove)

        let _status = false;

        if (props.userType && props.firstName && props.lastName && props.email && checkApprove) {
            console.log("checkButtonStatus return false");
            _status = true;
        }

        if (_status && props.userType === 'company') {
            console.log("checkButtonStatus company", props.title, "2", props.companyType, "3", props.companyName, "4", props.companyWebSite)

            if (props.title && props.companyType && props.companyName && props.companyWebSite) {
                _status = true;
            } else {
                _status = false;
            }
        }
        if (_status && props.userType === 'artist') {
            console.log("checkButtonStatus artist", props.contacts)

            if (props.contacts?.length > 0 || contact?.length) {
                _status = true;
            } else {
                _status = false;
            }
        }

        if (_status && (action === 'verification' || action === 'reference')) {
            if (props.userName && props.password && props.passwordConfirm) {
                _status = true;

            }
            else {
                _status = false;
            }
        }
        console.log("checkButtonStatus return last", _status);
        return !_status;

    }


    const onRegister = () => {

        console.log(props.userType, props.firstName, props.lastName, props.email)



        console.log("onRegister");
        if (props.firstName?.length > 0 && props.lastName?.length > 0 && props.email?.length > 0) {
            setDisplayLoadingDialog(true);

            const apiParams = {
                userType: props.userType, firstName: props.firstName, lastName: props.lastName, email: props.email,
                commercialMail: checkCommercialMail?'Y':'N',

            };
            if (props.userType === 'company') {
                apiParams.title = props.title;
                apiParams.companyName = props.companyName;
                if (props.companyName?.id) {
                    apiParams.companyId = props.companyName?.id;
                    apiParams.companyName = props.companyName?.name;
                }

                //
                apiParams.companyType = props.companyType;

                apiParams.address = props.address;
                apiParams.companyPhoneNumber = props.companyPhoneNumber;
                apiParams.companyWebSite = props.companyWebSite;

            }
            if (props.userType === 'artlover') {
                apiParams.verificationToken = verificationToken;
            }

            if (props.userType === 'artist') {
                let _contacts = props.contacts;
                if (contact?.length > 0) {
                    let _contact = checkContact();
                    _contacts = [...props.contacts, _contact];


                }
                console.log("_contacts", _contacts, _contacts?.length, "3", _contacts?.sizze);
                if (_contacts?.length == 0) {

                    toast.current.show({ severity: 'error', summary: t("global_error"), detail: t("register_no_portfolio"), life: 5000 });
                    setDisplayLoadingDialog(false);
                    return;
                }
                apiParams.details = { contacts: _contacts };
                console.log("onSave _contacts contact", _contacts);


            }


            console.log("onRegister", apiParams);

            AuthenticationService.register(apiParams).then(

                (response) => {

                    console.log("onRegister", response);

                    if (response?.data?.error) {
                        setDisplayLoadingDialog(false);

                        let _detail = response.data.error?.innerExceptionMessage;
                        if (t(_detail)) {
                            _detail = t(_detail);
                        }


                        toast.current.show({ severity: 'error', summary: t('global_text_errorsummary'), detail: _detail, life: 10000 });
                    } else {
                        console.log("onRegister", response);

                        setDisplayLoadingDialog(false);

                        props?.setDialogVisible(false);
                        let _detail = t('register_success_without_approval')
                        if (props.userType === 'artlover') {
                            _detail = t('register_success')
                        }
                        toast.current.show({ severity: 'success', summary: t('global_text_successsummary'), detail: _detail, life: 3000 });
                    }
                },
                (error) => {
                    setDisplayLoadingDialog(false);

                    const _content =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();

                    console.log(_content);

                    if (error?.response?.status === 403 || error?.Error?.includes("403")) {
                        EventBus.dispatch("logout", props);

                    } else {
                        toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                    }
                }
            );
        } else {
            toast.current.show({ severity: 'error', summary: t("global_error"), detail: t("global_error_detail"), life: 5000 });

        }


    }

    const onVerification = () => {

        console.log(props.email, props.userName, props.password, props.passwordConfirm)
        console.log(usermail, verificationToken, action, props.userName?.length > 0 && props.password?.length > 0 && props.password?.passwordConfirm > 0);


        console.log("onVerification");
        if (usermail, verificationToken, action, props.userName?.length > 0 && props.password?.length > 0 && props.passwordConfirm?.length > 0) {
            setDisplayLoadingDialog(true);

            const apiParams = {
                email: usermail,
                verificationToken: verificationToken,
                userName: props.userName,
                password: props.password,
                passwordConfirm: props.passwordConfirm
            };

            console.log("onVerification", apiParams);

            AccountService.accountVerification(apiParams).then(

                (response) => {

                    console.log("onVerification", response);

                    if (response?.data?.error) {
                        setDisplayLoadingDialog(false);

                        let _detail = response.data.error?.innerExceptionMessage;
                        if (t(_detail)) {
                            _detail = t(_detail);
                        }

                        toast.current.show({ severity: 'error', summary: t('global_text_errorsummary'), detail: _detail, life: 10000 });
                    } else {
                        console.log("onVerification", response);

                        setDisplayLoadingDialog(false);

                        //props?.setDialogVisible(false);
                        let _detail = t('register_success')

                        //toast.current.show({ severity: 'success', summary: t('global_text_successsummary'), detail: _detail, life: 3000 });

                        // window.location.replace("/")
                        //props.history.push('/');

                        onLogin(props.userName, props.password,);

                    }
                },
                (error) => {
                    setDisplayLoadingDialog(false);

                    const _content =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();

                    console.log(_content);

                    if (error?.response?.status === 403 || error?.Error?.includes("403")) {
                        EventBus.dispatch("logout", props);

                    } else {
                        toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                    }
                }
            );
        } else {
            toast.current.show({ severity: 'error', summary: t("global_error"), detail: t("verification_error_descr2"), life: 5000 });

        }


    }

    const onLogin = (username, password) => {
        showLoading();
        //if (captchaCheck) {
        try {
            AuthenticationService.signin(username, password).then(response => {
                console.log("signin", response);

                if (response?.data?.error) {
                    hideLoading();
                    let _content = response?.data?.error?.message ? response?.data?.error?.message : response?.data?.error?.innerExceptionMessage;

                    if (t(_content)) {
                        _content = t(_content);
                    }



                    toast.current.show({ severity: 'error', summary: t("global_error"), detail: _content, life: 5000 });


                } else if (response?.status >= 200 && response?.status < 300) {

                    console.log("signin", response);
                    console.log(JSON.stringify(response?.data?.data?.response));
                    const accessToken = response?.data?.data?.response;
                    console.log(accessToken);

                    AuthService.setAuthentication(accessToken);

                    let _detail = t('register_success')


                    //toast.current.show({ severity: 'success', summary: t('global_text_successsummary'), detail: t('global_success'), life: 3000 });
                    hideLoading();
                    toast.current.show({ severity: 'success', summary: t('global_text_successsummary'), detail: _detail, life: 3000 });
                    props.clear();
                    navigate('/');

                }
                else if (response?.status === 400) {
                    hideLoading();
                    toast.current.show({ severity: 'error', summary: t("global_error") + response?.status, detail: t("global_error_login_missingusernamepassword"), life: 5000 });
                } else if (response?.status === 401) {
                    hideLoading();
                    toast.current.show({ severity: 'error', summary: t("global_error") + response?.status, detail: t("global_error_login_unauthorized"), life: 5000 });
                } else if (response?.status === 422) {
                    hideLoading();
                    toast.current.show({ severity: 'error', summary: t("global_error") + response?.status, detail: t("global_error_login_invallidusernamepassword"), life: 5000 });
                } else {
                    hideLoading();
                    toast.current.show({ severity: 'error', summary: t("global_error") + response?.status, detail: t("global_error_login_missingusernamepassword"), life: 5000 });

                }
            })
                .catch(err => {
                    hideLoading();

                    if (!err?.response) {
                        toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_detail"), life: 5000 });
                    } else if (err.response?.status === 400) {
                        toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_login_missingusernamepassword"), life: 5000 });
                    } else if (err.response?.status === 401) {
                        toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_login_unauthorized"), life: 5000 });
                    } else if (err.response?.status === 422) {
                        toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_login_invallidusernamepassword"), life: 5000 });
                    } else {
                    }
                    console.error(err);
                });


        } catch (err) {
            hideLoading();
            if (!err?.response) {
                toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_detail"), life: 5000 });
            } else if (err.response?.status === 400) {
                toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_login_missingusernamepassword"), life: 5000 });
            } else if (err.response?.status === 401) {
                toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_login_unauthorized"), life: 5000 });
            } else if (err.response?.status === 422) {
                toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_login_invallidusernamepassword"), life: 5000 });
            } else {
                toast.current.show({ severity: 'error', summary: t("global_error") + err?.response?.status, detail: t("global_error_detail"), life: 5000 });
            }
            console.error(err);
            //	errRef.current.focus();
        }
    }

    const artistInfo = () => {

        return (

            <div className="col-12 md:col-12 flex justify-content-center " >
                <div className="register-content  w-12   p-3">
                    <div className="col-12 md:col-12" style={{
                        wordWrap: 'break-word',
                        paddingBottom: 5,
                    }}>
                        {t('register_descr5')}
                    </div>
                    {
                        renderContacts()
                    }

                </div>
            </div>

        )
    }

    const companyInfo = () => {

        return (

            <div className="col-12 md:col-12 flex justify-content-center " >
                <div className="register-content  w-12  p-3">
                    <div className="col-12 md:col-12 p-2 " style={{
                        wordWrap: 'break-word',
                        paddingBottom: 5,
                    }}>
                        {t('register_descr3')}
                    </div>
                    <div className="grid p-2">
                        <div className="col-12 md:col-6">

                            <Dropdown id="register_company_type" value={props.selectedCompanyType} onChange={(e) => onSelectedCompanyType(e.value)} options={props.companyTypes} optionLabel="name"
                                placeholder={t('register_company_type')} filter
                                className="w-full  inputtext_raunded" />
                        </div>
                        <div className="col-12 md:col-6">

                            <InputText id="companyName" value={props.companyName} onChange={(e) => props.setCompanyName(e.target.value)}
                                className="inputtext_raunded p-inputtext " type="text" placeholder={t('register_company_name')}></InputText>
                        </div>
                        <div className="col-12 md:col-6">

                            <InputText value={props.title} onChange={(e) => props.setTitle(e.target.value)}
                                type="text" placeholder={t('register_title')} className="inputtext_raunded p-inputtext " />
                        </div>



                        <div className="col-12 md:col-6">
                            <InputText id="companyWebSite" value={props.companyWebSite} onChange={(e) => props.setCompanyWebSite(e.target.value)}
                                className="inputtext_raunded p-inputtext " type="text" placeholder={t('global_text_website')}></InputText>

                        </div>

                    </div>
                </div>
            </div>

        )
    }

    const authInfo = () => {
        if (props.userType) {
            return (
                <div className="col-12 md:col-12 flex justify-content-center  " >
                    <div className="register-content w-12   p-3">
                        <div className="col-12 md:col-12" style={{
                            wordWrap: 'break-word',
                            paddingBottom: 5,
                        }}>
                            {t('register_descr2')}
                        </div>
                        <div className="col-12 md:col-12">
                            <div className="grid formgrid">
                                <div className="col-12 lg:col-3 mb-2">
                                    <InputText id="firstname" value={props.firstName} onChange={(e) => props.setFirstName(e.target.value)} type="text"
                                        placeholder={t('global_text_firstname')} className="inputtext_raunded p-inputtext "
                                        disabled={verificationUser}
                                    />
                                </div>

                                <div className="col-12  lg:col-3  mb-2">
                                    <InputText id="lastname" value={props.lastName} onChange={(e) => props.setLastName(e.target.value)}
                                        type="text" placeholder={t('global_text_lastname')} className="inputtext_raunded p-inputtext "
                                        disabled={verificationUser}
                                    />
                                </div>
                                <div className="col-12 lg:col-6  mb-2">
                                    <InputText id="email" value={props.email} onChange={(e) => props.setEmail(e.target.value)} autoComplete="off"
                                        disabled={verificationUser}
                                        className="inputtext_raunded p-inputtext " type="text" placeholder={t('global_text_email')}></InputText>
                                </div>

                            </div>
                        </div>
                        {!(action === 'verification' || action === 'reference') &&
                            <div className="col-12 md:col-12">
                                <div  className="flex align-items-center">
                                    <Checkbox inputId="binary" checked={checkApprove} onChange={e => setCheckApprove(e.checked)} />

                                    <a onClick={() => setDisplayKVKK(true)} style={{ paddingLeft: '2px', paddingRight: '2px' ,cursor: 'pointer'}} >{t('global_text_approvekvkk')}</a>
                                    {t('global_text_approvelast')}
                            
                                </div>
                                <div  className="flex align-items-center  mt-2">
                                    <Checkbox inputId="binary" checked={checkCommercialMail} onChange={e => setCheckCommercialMail(e.checked)} className='mr-1' />

                                   {t('global_text_commercialmail')}

                                </div>
                            </div>
                        }
                        {
                            props.userType === 'artlover' && action != 'reference' &&

                            <div className="col-12 md:col-12 text-700 text-sm" style={{
                                wordWrap: 'break-word',
                                paddingBottom: 5,
                            }}>
                                {t('register_no_reference')}
                            </div>
                        }
                    </div>
                </div>
            )
        }
    }

    const renderWizard = () => {
        console.log("renderWizard", props.userType);
        if (!props.userType) {
            return
            (
                <></>
            )
        }
        console.log("renderWizard", usermail, verificationToken, props.userType);

        if (props.userType === 'artist' && !verificationUser) {
            return (
                <>
                    {artistInfo()}
                </>
            )
        }
        if (props.userType === 'company' && !verificationUser) {
            return (
                <>
                    {companyInfo()}
                </>
            )
        }
    }


    const renderUserType = () => {
        return (
            <div className=" flex justify-content-center p-2 w-12">
                <div className="grid register-content w-fit flex justify-content-center  p-3">

                    {Constants.userTypes.map((userType, index) => {
                        //
                        return (

                            <div className="card_member  text-xs flex flex-column flex align-items-center justify-content-center m-2 user-type-box"
                                onClick={() => { onSelectUserType(userType.type) }}
                                style={{
                                    backgroundColor: props.userType === userType.type ? 'black' : 'white',
                                    color: props.userType === userType.type ? 'white' : 'black',

                                }}
                            >
                                <img src={props.userType === userType.type ? userType.icon_active : userType.icon} style={{ paddingBottom: 3 }} width={35}
                                    alt={userType.type}
                                ></img>
                                {t(userType.descr)}
                            </div>
                        )
                    })
                    }


                </div>
            </div>

        )

    }



    const renderRegisterInfo = () => {

        return (
            <>
                <div className="grid p-2 w-12" >
                    {authInfo()}

                    {renderWizard()}
                </div>
            </>
        )

    }
    const renderButton = () => {
        if (verificationUser) {
            return (
                <div className=" flex justify-content-center p-1 w-12">
                    <div className=" w-fit ">
                        <Button label={t("register_complate")} className="p-button-rounded mr-2 mb-2" disabled={checkButtonStatus()}
                            onClick={() => onVerification()}

                        />
                    </div>

                </div>
            )
        } else {
            if (props.userType) {

                return (
                    <div className=" flex justify-content-center p-1 w-12">
                        <div className=" w-fit ">
                            <Button label={t("register_complate")} className="p-button-rounded mr-2 mb-2" disabled={checkButtonStatus()}
                                onClick={() => onRegister()}

                            />
                        </div>

                    </div>
                )
            }
        }
    }
    return (
        <div className="grid p-fluid flex justify-content-center p-2" style={{ maxWidth: 650 }}>
            <Toast ref={toast} />

            <Dialog visible={displayLoadingDialog} breakpoints={{ '960px': '75vw' }} closable={false} className='p-dialog-load' header={<></>} >
                <div>
                    <img src="/assets/layout/images/page-loader.gif" alt='Loading...' width="125px" height="125px">
                    </img>
                </div>
            </Dialog>

            {renderUserType()}
            {renderRegisterInfo()}
            {passwordInfo()}

            {renderButton()}

            <Dialog visible={displayKVKK} onHide={() => setDisplayKVKK(false)} style={{ width: '80vw', height: '100vh', maxHeight: '100vh' }} maximized={true}>
                <ContractDetail resourceCode="kvkk"></ContractDetail>
            </Dialog>


        </div>
    )
}

export default CustomRegister;